module.exports = __webpack_public_path__ + "media/src/assets/Images/Banred-7a591c53e32d4e2963b9ef4b7cca5e03.svg";